import CardUtil from './CardUtil'

class Hand extends Array {

  constructor(numCards, noCard) {
    super(numCards)
    this.noCard = noCard
    this.init() // so that forEach works...
  }

  toHuman(){
    return this.filter( cCard => {
      return cCard != this.noCard
    } )
      .map(cCard => CardUtil.cCard2Card(cCard))
      .join(',')
  }

  static equal(hand1, hand2) {
    return hand1 &&
           hand2 &&
           hand1.length === hand2.length &&
           Array.from(hand1).sort().every(
             function (value, index) {
               return value === Array.from(hand2).sort()[index]
              }
           )
  }

  equal(otherHand){
    return Hand.equal(this, otherHand)
  }


  init(){
    for (let i = 0; i < this.length; i++) {
      this[i] = this.noCard
    }
  }

  set(cards){
    this.forEach(
      (_, i) => {this[i] = cards[i] || this.noCard}, this
    )

  }

  num_not_noCard(){
    let n = 0
    for (let i = 0; i < this.length; i++) {
      if (this[i] != this.noCard) n+=1
    }
    return n
  }

  contains(card){
    const j = this.indexOf(card)
    return (j >= 0)
  }

  removeCard(card) {
    const j = this.indexOf(card)
    if (j < 0) return 0
    this[j] = this.noCard
    return 1
  }

  // in first empty slot
  addCard(newCard) {
    let delta = 0
    for (let i = 0; i < this.length; i++) {
      if (this[i] == this.noCard) {
        this[i] = newCard
        delta = 1
        break
      }
    }
    return delta
  }

}

export default Hand